import Vue from 'vue'
import { TYPE_PHOTO } from 'util/media-utils'

// the standard for the largest thumbnail size. standard meaning 'not customized'
const STANDARD_LARGE_SIZE = 160

/**
 *  Methods used by media.ts, media-thumb.ts, and media-submission-thumb.ts
 */
export default Vue.extend({
  props: {
    media: {
      type: Object,
      required: true
    },
    size: Number
  },
  computed: {
    durationScaling() {
      if (!this.size || this.size >= STANDARD_LARGE_SIZE) {
        return ''
      }
      // this equation makes an image at 80px (half of large size) to have a timestamp that is
      // 80% if the normal size.  1-to-1 scaling made it get to small (or large)
      const scaledValue = (100 - ((STANDARD_LARGE_SIZE * .25) - (this.size * .25))) / 100
      // scale the size of the duration display so not too big for smaller images (video thumbnails)
      return `transform: scale(${scaledValue})`
    },
    isImage() {
      return this.media.type === TYPE_PHOTO
    }
  },
  methods: {
    getPanAndZoomDimensions(w, h, maxW, maxH) {
      let newW = maxW
      let newH = maxH
      if (w > h && h >= maxH) {
        newW = Math.floor((w / h) * maxW)
      } else if (h > w && w > maxW) {
        newH = Math.floor((h / w) * maxH)
      } else if (w < maxW || h < maxH) {
        newW = w
        newH = h
      }
      return { width: newW, height: newH }
    },
    getStyleString(cssProps) {
      const pixelProps = ['width', 'height', 'top', 'left']
      let styles = ''
      Object.keys(cssProps).forEach((p) => {
        const suffix = pixelProps.indexOf(p) > -1 ? 'px' : ''
        styles += `${p}:${cssProps[p]}${suffix};`
      })
      return styles
    },
    getImagePositioning(w, h, maxW, maxH) {
      return {
        top: this.getPosition(h, maxH),
        left: this.getPosition(w, maxW)
      }
    },
    getPosition(value, maxValue) {
      if (value > maxValue) {
        return -Math.floor((value - maxValue) / 2)
      }
      return Math.floor((maxValue - value) / 2)
    },
    isOrientation90or270(orientation) {
      return [5, 6, 7, 8].indexOf(orientation) !== -1
    }
  }
})
